import $http from '@/services/http-common'

export default {
  state: {
    list: {},
    lists: [],
    navBarLists: []
  },
  mutations: {
    setList (state, payload) {
      state.list = payload
    },
    setNavBarLists (state, payload) {
      state.navBarLists = payload
    }
  },
  actions: {
    async loadLists ({ commit }, payload) {
      let query = '/api/lists'
      if (payload && payload.limit) {
        query = `${query}?limit=${payload.limit}`
      }
      const { data } = await $http.get(query)
      commit('setNavBarLists', data)
    }
  },
  getters: {
    getList (state) {
      return state.list
    },
    getNavBarLists (state) {
      return state.navBarLists
    }
  }
}
